export function BrandRibbon() {
  return <div className="brand-ribbon" aria-hidden="true" />;
}
